import routeNames from '@/router/names'
import useProfileStore from '@/stores/profile.store'

/**
 *
 * @param {Object} item Deleted item from which we should redirect to closest element
 * @returns Link of closest element
 */
function getRedirectAfterDelete(item) {
  if (item) {
    // Redirect to next item
    if (item.next) {
      return item.next.link
    }
    // Fallback to previous item if there is no next item
    if (item.previous) {
      return item.previous.link
    }
    // Fallback to parent item if there is no previous item
    if (item.parent) {
      return item.parent.link
    }
  }
  // Fallback to global editor if there is no parent item
  const profileStore = useProfileStore()
  return {
    name: routeNames.GlobalEditor,
    params: {
      profileUid: profileStore.profileUid,
    },
  }
}

export default getRedirectAfterDelete
